import { JetView } from "webix-jet";

import FoldersTree from "../folders";

export default class SideTreeView extends JetView {
	config() {
		return {
			view: "sidemenu",
			localId: "sidemenu",
			css: "webix_files_sidemenu",
			width: 300,
			animate: false,
			state: state => {
				const toolbarHeight = webix.skin.$active.toolbarHeight + 14;
				state.left = this.Parent.left;
				state.top = this.Parent.top + toolbarHeight;
				state.height = this.Parent.height - toolbarHeight;
			},
			body: FoldersTree,
		};
	}
	init() {
		this.on(this.app, "view:resize", () => {
			if (this.getRoot().isVisible()) this.Show(true);
		});
	}
	Show(updatePos) {
		if (!updatePos && this.getRoot().isVisible()) return;

		this.Parent = this.app.getRoot().$view.getBoundingClientRect();
		this.$$("sidemenu").show();
	}
}
